// extracted by mini-css-extract-plugin
export default {"headerWrap":"BackOfficePdf_headerWrap__8kPPN","headerWrapInner":"BackOfficePdf_headerWrapInner__ux8vz"};